import { render, staticRenderFns } from "./zhongzhi_menu.vue?vue&type=template&id=00dbaaaa&"
import script from "./zhongzhi_menu.vue?vue&type=script&lang=js&"
export * from "./zhongzhi_menu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports